import { StyledSection, StyledTitle } from '@/components/styles'
import generateAnchorsParams from '@/lib/generateAnchorsParams'
import { forwardRef } from 'react'

const ContentSection = forwardRef((props, ref) => {
  const { type, title, slug, noTitle, titleNeighbor, children,size="small",mb="small", HeaderComponent, ...other } = props
  const [generatedTitle] = generateAnchorsParams({ type, title, slug })

  return (
    <StyledSection
      id={type === 'block' ? slug : type}
      pt="medium"
      ref={ref}
      as={noTitle ? 'div' : 'section'}
      {...other}
    >
      {(generatedTitle || titleNeighbor) && (
        <StyledSection.Header>
          {!noTitle && (
            <StyledTitle size={size} mb={mb} as="h3" black>
              {generatedTitle}
            </StyledTitle>
          )}
          {titleNeighbor}
          {HeaderComponent && <HeaderComponent/>}
        </StyledSection.Header>
      )}

      {children}
    </StyledSection>
  )
})

export default ContentSection
